import { render, staticRenderFns } from "./Regiones.vue?vue&type=template&id=fe17ac64&scoped=true&"
import script from "./Regiones.vue?vue&type=script&lang=js&"
export * from "./Regiones.vue?vue&type=script&lang=js&"
import style0 from "./Regiones.vue?vue&type=style&index=0&id=fe17ac64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe17ac64",
  null
  
)

export default component.exports